"use strict";

export default class Homepage {
    constructor() {
        this.name = "homepage";

        var $options = {
            infinite: true,
            variableWidth: true,
            centerMode: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 2000,
            arrows: false,
            cssEase: "ease",
            slidesToScroll: 1,
            pauseOnHover: true,
            swipeToSlide: true
        }

        var normalSpeed = 3000;
        var quickSpeed = 500;

        var $slider = $("#block-views-block-content-blocks-homepage-featured-work .view-content");


        $("#block-views-block-content-blocks-homepage-featured-work h2").append(
            "<div><a class='js-injected view-all-work' href='/our-works'>All work</a></div>"
        );

        // if (
        //     $(
        //         "#block-views-block-content-blocks-homepage-featured-work .view-content > .views-row"
        //     ).length > 3
        // ) {
        //     setTimeout(() => {


        //         $slider.slick($options);


        //         // $slider.on('mouseenter', function () {
        //         //     var track = $('.slick-track')[0];
        //         //     // ORIGINAL cssText "opacity: 1; width: 30000px; transform: translate3d(-1400px, 0px, 0px); transition: transform 2000ms linear 0s;"
        //         //     // track.style.cssText = "opacity: 1; width: 30000px; transform: translate3d(-1400px, 0px, 0px); transition: transform 500ms linear 0s;"
        //         //     $slider.slick('unslick');
        //         // }).on('mouseleave', function () {
        //         //     $slider.slick($options);
        //         // });


        //     }, 100);
        // }
    }
}
